import { cn } from "@repo/ui/lib/utils";
import { getChildByType } from "react-nanny";
import styles from "./Footer.module.css";

function FooterPrimaryItem({
  children,
  className,
}: Readonly<{
  children?: React.ReactNode;
  className?: string;
}>): React.ReactNode {
  return <div className={className}>{children}</div>;
}

function FooterSecondaryItem({
  children,
  className,
}: Readonly<{
  children?: React.ReactNode;
  className?: string;
}>): React.ReactNode {
  return <div className={className}>{children}</div>;
}

function FooterTertiaryItem({
  children,
  className,
}: Readonly<{
  children?: React.ReactNode;
  className?: string;
}>): React.ReactNode {
  return <div className={className}>{children}</div>;
}

type FooterProps = Readonly<{
  className?: string;
  children: React.ReactNode;
}>;

export default function Footer({ className, children }: FooterProps): React.ReactElement {
  const primaryFooterItem = getChildByType(children, FooterPrimaryItem);
  const secondaryFooterItem = getChildByType(children, FooterSecondaryItem);
  const tertiaryFooterItem = getChildByType(children, FooterTertiaryItem);

  return (
    <footer className={cn(className, styles.footer, "flex items-center justify-center")}>
      <div className="rounded-lg bg-background/50 w-full max-w-3xl py-6 space-y-6">
        {primaryFooterItem}
        {tertiaryFooterItem}
        {secondaryFooterItem}
      </div>
    </footer>
  );
}

Footer.PrimaryItem = FooterPrimaryItem;
Footer.SecondaryItem = FooterSecondaryItem;
Footer.TertiaryItem = FooterTertiaryItem;
